import { request } from '@services'
import {
  NOTIFICATION_STATUS,
  NOTIFICATION_STATUS_NAME,
  STATUS_REQUEST,
  NOTIFICATION_FILTER_DIFFER_NULL,
} from '@utils/constant'
import { ObjectHelper } from '@utils/helpers'

export const state = {
  loading: false,
  data: null,
  errors: null,
  quotes: null,
  detail: null,
  previewCount: null,
  addStatus: '',
  editStatus: '',
  deleteStatus: '',
  deliverEnd: '',
  acceptRevoke: '',
  rejectRevoke: '',
  requestRevoke: '',
}

export const getters = {
  getNotificationList(state) {
    const list = state.data?.list?.map((item) => {
      const data = { ...item }
      Object.keys(item).forEach((key) => {
        if (
          !item[key] &&
          !['created_name', 'updated_name', 'hits', 'clicks'].includes(key)
        ) {
          data[key] = '-'
        }
      })
      data.notification_id = item.id
      data.place = 'アプリ'
      data.order = item.order >= 99 || item.company ? '-' : item.order
      if (item.place === 0) {
        data.hits = '-'
        data.clicks = '-'
        data.place = 'cms'
      }
      data.status = NOTIFICATION_STATUS[item.status]
      if (
        [
          NOTIFICATION_STATUS_NAME.END_OF_DELIVERY,
          NOTIFICATION_STATUS_NAME.DISABLED,
        ].includes(item.status)
      ) {
        data._classes = 'disabled-cell-by-status'
      }
      return data
    })
    return list
  },
  getNotificationPaginate(state) {
    const paginate = ObjectHelper.removePropertyByKey('list')({ ...state.data })
    return paginate
  },
  getQuotes(state) {
    return state.quotes
  },
  getNotificationDetail(state) {
    return state.detail
  },
  getPreviewCount(state) {
    return state.previewCount
  },
  getStatusAddRequest(state) {
    return state.addStatus
  },
  getDeleteStatusRequest(state) {
    return state.deleteStatus
  },
  getDeliverStatusRequest(state) {
    return state.deliverEnd
  },
  getAcceptRevokeStatusRequest(state) {
    return state.acceptRevoke
  },
  getRejectRevokeStatusRequest(state) {
    return state.rejectRevoke
  },
  getRequestRevokeStatusRequest(state) {
    return state.requestRevoke
  },
}

export const mutations = {
  SET_NOTIFICATION_REQUESTED(state) {
    state.loading = true
  },
  SET_NOTIFICATION_RECEIVED(state, newValue) {
    state.loading = false
    state.data = newValue
    state.errors = null
  },
  SET_NOTIFICATION_FAILURE(state, error) {
    state.loading = false
    state.errors = error
  },
  RESET_NOTIFICATION(state) {
    state.loading = false
    state.data = null
    state.errors = null
  },
  SET_QUOTE_RECEIVED(state, newValue) {
    state.quotes = newValue
  },
  RESET_QUOTE(state) {
    state.quotes = null
  },
  SET_NOTIFICATION_DETAIL_RECEIVED(state, newValue) {
    state.detail = newValue
  },
  RESET_NOTIFICATION_DETAIL(state) {
    state.detail = null
  },
  SET_NOTIFICATION_PREVIEW_COUNT_RECEIVED(state, newValue) {
    state.previewCount = newValue
  },
  RESET_PREVIEW_COUNT(state) {
    state.previewCount = null
  },
  SET_NOTIFICATION_REGISTER_RECEIVED(state) {
    state.addStatus = STATUS_REQUEST.SUCCESS
  },
  SET_NOTIFICATION_REGISTER_RECEIVED_FAILED(state) {
    state.addStatus = STATUS_REQUEST.FAILED
  },
  RESET_NOTIFICATION_REGISTER(state) {
    state.addStatus = ''
  },
  SET_EDIT_NOTIFICATION_RECEIVED(state) {
    state.editStatus = STATUS_REQUEST.SUCCESS
  },
  SET_EDIT_NOTIFICATION_RECEIVED_FAILED(state) {
    state.editStatus = STATUS_REQUEST.FAILED
  },
  RESET_EDIT_NOTIFICATION(state) {
    state.editStatus = ''
  },
  SET_DELETE_NOTIFICATION_RECEIVED(state) {
    state.deleteStatus = STATUS_REQUEST.SUCCESS
  },
  SET_DELETE_NOTIFICATION_RECEIVED_FAILED(state) {
    state.deleteStatus = STATUS_REQUEST.FAILED
  },
  RESET_DELETE_NOTIFICATION(state) {
    state.deleteStatus = ''
  },
  SET_DELIVER_END_NOTIFICATION_RECEIVED(state) {
    state.deliverEnd = STATUS_REQUEST.SUCCESS
  },
  SET_DELIVER_END_NOTIFICATION_RECEIVED_FAILED(state) {
    state.deliverEnd = STATUS_REQUEST.FAILED
  },
  RESET_DELIVER_END_NOTIFICATION(state) {
    state.deliverEnd = ''
  },
  SET_ACCEPT_REVOKE_RECEIVED(state) {
    state.acceptRevoke = STATUS_REQUEST.SUCCESS
  },
  SET_ACCEPT_REVOKE_RECEIVED_FAILED(state) {
    state.acceptRevoke = STATUS_REQUEST.FAILED
  },
  RESET_ACCEPT_REVOKE(state) {
    state.acceptRevoke = ''
  },
  SET_REJECT_REVOKE_RECEIVED(state) {
    state.rejectRevoke = STATUS_REQUEST.SUCCESS
  },
  SET_REJECT_REVOKE_RECEIVED_FAILED(state) {
    state.rejectRevoke = STATUS_REQUEST.FAILED
  },
  RESET_REJECT_REVOKE(state) {
    state.rejectRevoke = ''
  },
  SET_REQUEST_REVOKE_RECEIVED(state) {
    state.requestRevoke = STATUS_REQUEST.SUCCESS
  },
  SET_REQUEST_REVOKE_RECEIVED_FAILED(state) {
    state.requestRevoke = STATUS_REQUEST.FAILED
  },
  RESET_REQUEST_REVOKE(state) {
    state.requestRevoke = ''
  },
}

export const actions = {
  async fetchingNotificationList({ commit }, params) {
    commit('SET_NOTIFICATION_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/notification/list/',
        payload: { ...params },
      })
      commit('SET_NOTIFICATION_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_NOTIFICATION_FAILURE', error)
      return error
    }
  },
  async fetchingQuotes({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/notification/quote/',
        payload: { ...params },
      })
      commit('SET_QUOTE_RECEIVED', response)
      return response
    } catch (error) {
      return error
    }
  },
  async fetchingNotificationById({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/notification/get/',
        payload: { ...params },
      })
      for (const key in response.filter_obj) {
        if (response.filter_obj[key] === NOTIFICATION_FILTER_DIFFER_NULL) {
          response.filter_obj[key] = null
        }
      }
      commit('SET_NOTIFICATION_DETAIL_RECEIVED', response)
      return response
    } catch (error) {
      return error
    }
  },
  async fetchingPreviewCount({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/notification/preview_count/',
        payload: { ...params },
      })
      commit('SET_NOTIFICATION_PREVIEW_COUNT_RECEIVED', response)
      return response
    } catch (error) {
      return error
    }
  },
  async registerNotification({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/notification/add/',
        payload: { ...params },
      })
      commit('SET_NOTIFICATION_REGISTER_RECEIVED')
      return response
    } catch (error) {
      commit('SET_NOTIFICATION_REGISTER_RECEIVED_FAILED')
      return error
    }
  },
  async editNotification({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/notification/edit/',
        payload: { ...params },
      })
      commit('SET_EDIT_NOTIFICATION_RECEIVED')
      return response
    } catch (error) {
      commit('SET_EDIT_NOTIFICATION_RECEIVED_FAILED')
      return error
    }
  },
  async deleteNotification({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/notification/delete/',
        payload: { ...params },
      })
      commit('SET_DELETE_NOTIFICATION_RECEIVED')
      return response
    } catch (error) {
      commit('SET_DELETE_NOTIFICATION_RECEIVED_FAILED')
      return error
    }
  },
  async deliverEndNotification({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/notification/stop/',
        payload: { ...params },
      })
      commit('SET_DELIVER_END_NOTIFICATION_RECEIVED')
      return response
    } catch (error) {
      commit('SET_DELIVER_END_NOTIFICATION_RECEIVED_FAILED')
      return error
    }
  },
  async acceptRevoke({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/notification/accept_revoke/',
        payload: { ...params },
      })
      commit('SET_ACCEPT_REVOKE_RECEIVED')
      return response
    } catch (error) {
      commit('SET_ACCEPT_REVOKE_RECEIVED_FAILED')
      return error
    }
  },
  async rejectRevoke({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/notification/reject_revoke/',
        payload: { ...params },
      })
      commit('SET_REJECT_REVOKE_RECEIVED')
      return response
    } catch (error) {
      commit('SET_REJECT_REVOKE_RECEIVED_FAILED')
      return error
    }
  },
  async requestRevoke({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/notification/request_revoke/',
        payload: { ...params },
      })
      commit('SET_REQUEST_REVOKE_RECEIVED')
      return response
    } catch (error) {
      commit('SET_REQUEST_REVOKE_RECEIVED_FAILED')
      return error
    }
  },
  resetAfterRegister({ commit }) {
    commit('RESET_QUOTE')
    commit('RESET_NOTIFICATION_DETAIL')
    commit('RESET_PREVIEW_COUNT')
    commit('RESET_NOTIFICATION_REGISTER')
  },
  resetDetails({ commit }) {
    commit('RESET_QUOTE')
    commit('RESET_NOTIFICATION_DETAIL')
    commit('RESET_PREVIEW_COUNT')
    commit('RESET_EDIT_NOTIFICATION')
    commit('RESET_DELETE_NOTIFICATION')
  },
  resetAfterStop({ commit }) {
    commit('RESET_DELIVER_END_NOTIFICATION')
  },
  resetAfterAccept({ commit }) {
    commit('RESET_ACCEPT_REVOKE')
  },
  resetAfterReject({ commit }) {
    commit('RESET_REJECT_REVOKE')
  },
  resetAfterRequest({ commit }) {
    commit('RESET_REQUEST_REVOKE')
  },
}
